module.exports = __webpack_public_path__ + "static/media/inconvergent-3.49512b45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/inconvergent-3.jpg
// module id = 427
// module chunks = 12